import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'qset-generator-results';

const ELEMENTS = define({
  // The stat cards' titles cannot serve as text handles: "ผ่านเกณฑ์" is a
  // substring of "ไม่ผ่านเกณฑ์", so filtering for the passed card also matches
  // the failed one.
  TOTAL_QSETS_VALUE_TEXT: ['total-qsets-value', 'text'],
  DUPLICATION_RATE_VALUE_TEXT: ['duplication-rate-value', 'text'],
  PASSED_VALUE_TEXT: ['passed-value', 'text'],
  FAILED_VALUE_TEXT: ['failed-value', 'text'],
  // Label carries the live selection count ("Confirm Selected (2)").
  CONFIRM_SELECTED_BUTTON: ['confirm-selected', 'button'],
});

export const QSET_GENERATOR_RESULTS_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
